import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CLIENT_FEATURE_KEY, ClientState } from './client.reducer';

export const selectClientState = createFeatureSelector<ClientState>(CLIENT_FEATURE_KEY);

export const selectClients = createSelector(selectClientState, (state) => state?.data ?? null);
export const selectClientDetail = createSelector(selectClientState, (state) => state?.detail ?? null);
export const selectClientsTotal = createSelector(selectClientState, (state) => state?.total ?? 0);
export const selectClientsQuery = createSelector(selectClientState, (state) => state?.query ?? null);
export const selectClientsLoading = createSelector(selectClientState, (state) => state?.loading ?? false);
export const selectClientsError = createSelector(selectClientState, (state) => state?.error ?? null);
